import moment from 'moment-timezone';
moment.tz.setDefault("Asia/Bangkok");
moment.locale('vi');

export default moment
